module.exports = __webpack_public_path__ + "static/media/Reminders.76024261.svg";